import type {ReactElement, Ref} from 'react';
import React from 'react';
import type {MiddleClickNewTabProps} from './middle-click-new-tab.types';
import {MouseButton} from '@Utils/dom.util';

function MiddleClickNewTab({href, children, className}: MiddleClickNewTabProps, ref: Ref<HTMLSpanElement>): ReactElement {
  return (
    <span
      ref={ref}
      className={className}
      onMouseDown={(e) => {
        if ((e.button as MouseButton) !== MouseButton.MIDDLE) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        window.open(href, '_blank', 'noopener');
      }}
    >
      {children}
    </span>
  );
}

export default React.forwardRef(MiddleClickNewTab);
